"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppView = void 0;
/**
 * @react-component App - the main app view that starts it all!
 */
var React = require("react");
var react_redux_1 = require("react-redux");
var store_1 = require("./store");
var constants_1 = require("./constants");
var PAGES = constants_1.default.PAGES;
var subnav_view_1 = require("./layout/subnav.view");
var layout_view_1 = require("./layout/layout.view");
var noauth_view_1 = require("./layout/noauth.view");
var placeholder_view_1 = require("./containers/placeholder.view");
var modal_component_1 = require("./components/modal.component");
var flow_component_1 = require("./components/flow.component");
var modal_view_selection_1 = require("./modal-view-selection");
var tab_panel_view_1 = require("./tab-panel.view");
var route_utils_1 = require("./route.utils");
function checkForChildInParent(Parent, Child) {
    var hidebackButton = false;
    function helper(parent, child) {
        for (var key in child) {
            if (typeof parent[key] === "object" &&
                "object" === typeof child[key]) {
                helper(parent[key], child[key]);
            }
            else {
                hidebackButton = hidebackButton || parent[key] === child[key];
            }
        }
    }
    helper(Parent, Child);
    return hidebackButton;
}
function App(_a) {
    var store = _a.store;
    var state = store.getState();
    var route = state.route || {};
    var isFlow = route.isFlow || false, isLoggedOut = state.pageInfo.isLoggedOut, navigation = state.navigation, View, SubView = modal_view_selection_1.modalViewSelection(state); // Modal represents overpanel or flow panel
    if (SubView && typeof SubView.isBackHidden !== "boolean") {
        SubView.isBackHidden = checkForChildInParent(state, SubView.isBackHidden);
    }
    if (SubView) {
        // either Modal or FLow
        var SubViewType = SubView.view, Component = isFlow ? flow_component_1.default : modal_component_1.default;
        View = (React.createElement(Component, { header: SubView.header, cancelUrl: SubView.cancelUrl, isCloseXHidden: SubView.isCloseXHidden, isBackHidden: SubView.isBackHidden, showNavigation: state.account.showNavigation, flow: route.enter.flow, transitionOutHandler: route_utils_1.transitionOutHandler },
            React.createElement(SubViewType, { route: route, content: state.content, params: route.enter.params, transitionOutHandler: route_utils_1.transitionOutHandler })));
    }
    else {
        View = modal_view_selection_1.getSubView(state);
    }
    if (isLoggedOut) {
        return (React.createElement(react_redux_1.Provider, { store: store },
            React.createElement(noauth_view_1.default, null, route.enter.view === PAGES.UNSUBSCRIBE && React.createElement(placeholder_view_1.default, null))));
    }
    if (View) {
        if (isFlow) {
            // just show the overpanel modal
            return (React.createElement(react_redux_1.Provider, { store: store },
                React.createElement(layout_view_1.default, null, View)));
        }
        else {
            // show full app
            var desktopHeaderHtml = { __html: navigation.desktopHeaderHtml }, mobileHeaderHtml = { __html: navigation.mobileHeaderHtml }, footerHtml = { __html: navigation.footerHtml };
            return (React.createElement(react_redux_1.Provider, { store: store },
                React.createElement(layout_view_1.default, null,
                    React.createElement("div", { dangerouslySetInnerHTML: desktopHeaderHtml }),
                    React.createElement("div", { className: "vx_foreground-container foreground-container" },
                        React.createElement("div", { dangerouslySetInnerHTML: mobileHeaderHtml }),
                        React.createElement("div", { className: "container-fluid contents", id: "contents", role: "main", "aria-labelledby": "heading1" },
                            React.createElement("div", { id: "settings", className: "mainContents" },
                                React.createElement("h1", { id: "heading1", className: "accessAid" }, state.content.common.title),
                                React.createElement("div", { className: "settings" },
                                    React.createElement(subnav_view_1.default, null),
                                    React.createElement(tab_panel_view_1.default, null),
                                    React.createElement("div", { dangerouslySetInnerHTML: footerHtml }))))),
                    View)));
        }
    }
    else {
        return (React.createElement(react_redux_1.Provider, { store: store },
            React.createElement(layout_view_1.default, null, null)));
    }
}
// This default app view only used by react-engine to render 'store' into script tag in your HTML document
// @reference https://github.com/paypal/react-engine/blob/master/lib/server.js#L256
function ServerApp(props) {
    var store = store_1.createNewStore(props);
    return React.createElement(App, { store: store });
}
exports.default = ServerApp;
var mapStateToProps = function (state) { return state; };
exports.AppView = react_redux_1.connect(mapStateToProps)(App);
